/* global Provider */
import React, { Component } from 'react';

export default class RiskProfileChart extends Component {
    render() {
        let weightings = Provider.getSimplifiedWeightings();
        if (!weightings)return null;
        return (
            <div className="risk-profile">
                <h6>Risk Profile</h6>
                <div className="legend">
                    <label><b></b><span>&nbsp;</span></label>
                    <div className="slider">
                        <div className="knob top">Most Important Risk</div>
                        <div className="knob middle"></div>
                        <div className="knob bottom">Least Important Risk</div>
                    </div>
                </div>
                <div className="growth">
                    <label><b></b><span>Growth<br />Risk</span></label>
                    <div className="slider">
                        <div className="line">
                            <div className="grip" style={{ bottom: 'calc(' + weightings.growth + '% - 10px)' }}></div>
                        </div>
                        <div className="knob top"></div>
                        <div className="knob middle"></div>
                        <div className="knob bottom"></div>
                    </div>
                    <div className="description">
                        <h5><span>Growth Risk</span></h5>
                        Risk of not meeting an expected return goal
                    </div>
                </div>
                <div className="market">
                    <label><b></b><span>Market<br />Risk</span></label>
                    <div className="slider">
                        <div className="line">
                            <div className="grip" style={{ bottom: 'calc(' + weightings.market + '% - 10px)' }}></div>
                        </div>
                        <div className="knob top"></div>
                        <div className="knob middle"></div>
                        <div className="knob bottom"></div>
                    </div>
                    <div className="description">
                        <h5><span>Market Risk</span></h5>
                        Risk of a shortfall caused by the variability and timing of returns. Long-run Volatility, Sequence-of-Returns and Max Drawdown over 3-Years                     
                    </div>
                </div>
                <div className="macro">
                    <label><b></b><span>Macro<br />Scenario<br />Risk</span></label>
                    <div className="slider">
                        <div className="line">
                            <div className="grip" style={{ bottom: 'calc(' + weightings.macro + '% - 10px)' }}></div>
                        </div>
                        <div className="knob top"></div>
                        <div className="knob middle"></div>
                        <div className="knob bottom"></div>
                    </div>
                    <div className="description">
                        <h5><span>Macro Scenario Risk</span></h5>
                        The risk that changes in broad economic forces erode gains. Interest rate, inflation and currency
                    </div>
                </div>
                <div className="income">
                    <label><b></b><span>Income<br />Horizon<br />Risk</span></label>
                    <div className="slider">
                        <div className="line">
                            <div className="grip" style={{ bottom: 'calc(' + weightings.income + '% - 10px)' }}></div>
                        </div>
                        <div className="knob top"></div>
                        <div className="knob middle"></div>
                        <div className="knob bottom"></div>
                    </div>
                    <div className="description">
                        <h5><span>Income Horizon Risk</span></h5>
                        The risk that income won’t last over a long retirement
                    </div>
                </div>
                <div className="legend legend-end">
                    <label><b></b><span>&nbsp;</span></label>
                    <div className="slider">
                        <div className="knob top">Most Important Risk</div>
                        <div className="knob middle"></div>
                        <div className="knob bottom">Least Important Risk</div>
                    </div>
                </div>
                <h6>Risk Descriptions</h6>
            </div>
        );
    }
}